import { render, staticRenderFns } from "./UnassignedDeliveryOrders.vue?vue&type=template&id=2b19e2fc&"
import script from "./UnassignedDeliveryOrders.vue?vue&type=script&lang=js&"
export * from "./UnassignedDeliveryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports